if (!customElements.get('variant-carousel')) {
  customElements.define(
    'variant-carousel',
    class VariantCarousel extends HTMLElement {
      connectedCallback() {
        this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (!data.variant) return;
          this.renderVariant(data.variant.id);
        });
      }

      disconnectedCallback() {
        this.unsubscribeVariantChange?.();
      }

      renderVariant(variantId) {
        const url = `${this.dataset.productUrl}?section_id=${this.dataset.section}&variant=${variantId}`;

        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newContent = html.getElementById(this.dataset.contentId);
            const currentContent = this.querySelector(`#${this.dataset.contentId}`);
            if (!newContent || !currentContent) return;

            this.hidden = newContent.dataset.hasContent !== 'true';
            HTMLUpdateUtility.viewTransition(currentContent, newContent);
          })
          .catch((error) => console.error(error));
      }
    },
  );
}
